import TagManager from 'react-gtm-module';

import { useUTMParams } from '@app/hooks/useUTMTracker';
import { generateEventName } from '@app/utils/event';

export const useGADataLayer = () => {
  const utmParams = useUTMParams();
  const sendGAEvent = (eventName: string, isMobile = false) => {
    TagManager.dataLayer({
      dataLayer: {
        event: generateEventName(eventName, isMobile),
        ...utmParams.get(),
      },
    });
  };
  const sendGAEventNonPrefix = (eventName: string) => {
    TagManager.dataLayer({
      dataLayer: {
        event: eventName,
        ...utmParams.get(),
      },
    });
  };
  const sendGAConversionCompleteEvent = (
    eventName: string,
    orderId: string
  ) => {
    TagManager.dataLayer({
      dataLayer: {
        event: eventName,
        response_id: orderId,
        ...utmParams.get(),
      },
    });
  };
  return {
    sendGAConversionCompleteEvent,
    sendGAEvent,
    sendGAEventNonPrefix,
  };
};
